import React, { useState } from "react";
import { ChevronDown, Info } from "lucide-react";

export const HowWeCalculated = ({ assumptions = [] }) => {
  const [open, setOpen] = useState(false);
  if (!assumptions.length) return null;
  return (
    <div className="rounded-xl border border-lw-navy/10 bg-lw-ivory-warm/70">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        data-testid="how-we-calculated-toggle"
        aria-expanded={open}
        className="w-full flex items-center justify-between px-5 py-3.5 text-left"
      >
        <span className="flex items-center gap-2 font-sans-ui text-sm font-semibold text-lw-navy">
          <Info size={16} className="text-lw-gold" />
          How we calculated this
        </span>
        <ChevronDown
          size={18}
          className={`text-lw-navy/60 transition-transform ${
            open ? "rotate-180" : ""
          }`}
        />
      </button>
      {open && (
        <ul
          data-testid="how-we-calculated-list"
          className="px-5 pb-4 pt-1 space-y-2 list-disc list-inside text-sm text-lw-muted leading-relaxed"
        >
          {assumptions.map((a, i) => (
            <li key={i}>{a}</li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default HowWeCalculated;
